"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("@formily/vue");
var composition_api_1 = require("@vue/composition-api");
var vant_1 = require("vant");
var Text = (0, composition_api_1.defineComponent)({
    name: 'Text',
    props: ['value', 'style', 'mobileEllipse', 'canPaste', 'pasteTitle'],
    setup: function (curProps, _a) {
        var _this = this;
        var attrs = _a.attrs;
        var field = (0, vue_1.useField)().value;
        var handleClick = function () {
            var textContent = curProps.value || attrs.content;
            if (textContent) {
                (0, vant_1.Dialog)({
                    title: field.title || '文本内容',
                    message: textContent,
                    showConfirmButton: true,
                    confirmButtonText: '确定',
                    closeOnClickOverlay: true,
                });
            }
        };
        var handleCopy = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var props, textContent, textarea, successMsg, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.stopPropagation();
                        props = __assign(__assign(__assign({}, attrs), curProps), field.componentProps);
                        textContent = props.value || attrs.content;
                        if (!textContent) {
                            vant_1.Toast.fail('没有可复制的内容');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!(navigator.clipboard && window.isSecureContext)) return [3 /*break*/, 3];
                        return [4 /*yield*/, navigator.clipboard.writeText(textContent)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        textarea = document.createElement('textarea');
                        textarea.value = textContent;
                        textarea.style.position = 'fixed';
                        textarea.style.left = '-9999px';
                        document.body.appendChild(textarea);
                        textarea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textarea);
                        _a.label = 4;
                    case 4:
                        successMsg = props.pasteTitle || '复制成功';
                        vant_1.Toast.success({
                            message: successMsg,
                            duration: 3000,
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        vant_1.Toast.fail('复制失败，请手动复制');
                        console.error('复制失败:', err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        var renderCopyIcon = function (canPaste) {
            if (!canPaste) {
                return null;
            }
            return (0, vue_1.h)(vant_1.Icon, {
                attrs: {
                    name: 'description',
                    size: '14',
                    color: '#409eff',
                },
                style: {
                    marginLeft: '4px',
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                    flexShrink: '0',
                },
                on: {
                    click: handleCopy,
                },
            }, {});
        };
        return function () {
            var props = __assign(__assign(__assign({}, attrs), curProps), field.componentProps);
            var textContent = props.value || attrs.content;
            var canPaste = props.canPaste;
            var copyIcon = renderCopyIcon(canPaste);
            return !(attrs.mobileEllipse || props.mobileEllipse)
                ? (0, vue_1.h)(attrs.mode === 'normal' || !attrs.mode ? 'div' : attrs.mode, {
                    attrs: __assign(__assign(__assign({}, attrs), curProps), { style: 'white-space: pre-wrap;word-break:break-all' }),
                }, {
                    default: function () { return [textContent, copyIcon]; },
                })
                : (0, vue_1.h)(attrs.mode === 'normal' || !attrs.mode ? 'div' : attrs.mode, {
                    attrs: __assign(__assign(__assign({}, attrs), curProps), { style: 'text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' }),
                    on: {
                        click: handleClick,
                    },
                }, {
                    default: function () { return [textContent, copyIcon]; },
                });
        };
    },
});
exports.default = Text;
// import { h } from '@formily/vue';
// import { defineComponent } from '@vue/composition-api';
// const Text = defineComponent({
//   name: 'Text',
//   props: ['value', 'style'],
//   setup(curProps, { attrs }) {
//     return () => {
//       const props = {
//         ...attrs,
//         ...curProps,
//         style: 'white-space: pre-wrap;word-break:break-all',
//       };
//       return h(
//         attrs.mode === 'normal' || !attrs.mode ? 'div' : attrs.mode,
//         {
//           attrs: props,
//         },
//         {
//           default: () => [props.value || attrs.content],
//         }
//       );
//     };
//   },
// });
// export default Text;
